import React, { Component } from 'react'

import { AdminBannerInfoCard } from './adminBannerInfoCard'
import { User } from '../../../core/types'

export interface Props {
  user: User
}

export class AdminBannerOtherPanel extends Component<Props> {
  static displayName = 'AdminBannerOtherPanel'

  render() {
    const {
      user: { email, phone, organization },
    } = this.props as any
    const orgLabel = organization
      ? `${organization.nameLegal || organization.code || 'Organization'} (#${organization.id})`
      : '—'
    const phoneLabel = phone || '—'
    return (
      <div
        className="user-banner__other-panel"
        data-test="user-banner-other-panel"
      >
        <AdminBannerInfoCard title="Email address" content={email} />
        <AdminBannerInfoCard title="Phone" content={phoneLabel} />
        <AdminBannerInfoCard title="Organization" content={orgLabel} />
      </div>
    )
  }
}
